import { View } from "react-native";
import styled from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import React, { memo, useContext } from "react";
import { FilterScreenContext } from "@scenes/explore/FilterScreenContext";
import FilterSection from "../FilterSection";

type FilterSectionProps = {
  filterData: object[];
  style?: any;
  sectionName?: string;
  selectedProduct?: string;
  filterContainerWidth?: number;
  scrollRef?: any;
};

const UnifiedFilterSection = ({
  filterData,
  sectionName,
  selectedProduct,
  filterContainerWidth,
  scrollRef,
}: FilterSectionProps) => {
  const { fromResultScreen } = useContext(FilterScreenContext);
  const widthPercentage = 100 / filterData.length;

  return (
    <ChildContainer>
      {filterData.map((item, index) => (
        <View
          key={index}
          style={{
            width: `${widthPercentage}%`,
            paddingEnd: index < filterData.length - 1 ? SpaceType.Double : 0,
          }}
        >
          {
            <FiltersSection
              key={`normal-${index}`}
              filterData={item}
              sectionName={sectionName}
              selectedProduct={selectedProduct}
              fromResultScreen={fromResultScreen}
              filterContainerWidth={filterContainerWidth}
              fromUnifiedFilters={true}
              scrollRef={scrollRef}
            />
          }
        </View>
      ))}
    </ChildContainer>
  );
};

const ChildContainer = styled.View`
  flex-direction: row;
  width: 100%;
  opacity: 1;
`;

const FiltersSection = styled(FilterSection)`
  margin-top: ${SpaceType.Double}px;
  width: 100%;
`;

export default memo(UnifiedFilterSection);
